import React, { useEffect, useState } from 'react';
import { XIcon, CheckCircle } from 'lucide-react';
const purchases = [{
  name: 'Sarah M.',
  location: 'Austin, TX'
}, {
  name: 'James L.',
  location: 'Denver, CO'
}, {
  name: 'Emily R.',
  location: 'Chicago, IL'
}, {
  name: 'Michael T.',
  location: 'Boston, MA'
}, {
  name: 'Jessica K.',
  location: 'Seattle, WA'
}, {
  name: 'David W.',
  location: 'San Diego, CA'
}, {
  name: 'Amanda P.',
  location: 'Atlanta, GA'
}, {
  name: 'Robert H.',
  location: 'New York, NY'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-204" data-mp="22mf3kxtgu8zh">
          <div className="bg-white border-2 border-brand-gold shadow-[0_4px_22px_rgba(200,162,74,0.4)] rounded-lg p-2 pr-6 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-205" data-mp="1sqbxxhzens7s">
            <span className="absolute left-0 top-0 bottom-0 w-1.5 bg-brand-gold" data-id="element-206" data-mp="2ler3ldwncy6g" />
            <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close notification" data-id="element-207" data-mp="2gfefkpu1hl2a">
              <XIcon className="w-3.5 h-3.5" data-id="element-208" data-mp="150hn15yncdq6" />
            </button>

            <div className="flex items-center gap-2.5 pl-1" data-id="element-209" data-mp="10ynpv7nntrur">
              <div className="w-8 h-8 rounded-full bg-brand-gold/15 flex items-center justify-center shrink-0 border border-brand-gold/40" data-id="element-210" data-mp="10x2xnootil02">
                <CheckCircle className="w-4 h-4 text-brand-gold" data-id="element-211" data-mp="17ewdgh2lscq5" />
              </div>
              <div className="leading-tight" data-id="element-212" data-mp="17cjtxzh75uaz">
                <p className="font-bold text-brand-navy text-[13px]" data-id="element-213" data-mp="sglsc1oi7xrd">
                  {currentPurchase.name}
                </p>
                <p className="text-[10px] text-brand-muted font-medium" data-id="element-214" data-mp="xevp2gpvn6f3">
                  from {currentPurchase.location}
                </p>
                <p className="text-[11px] text-brand-navy font-bold mt-0.5" data-id="element-215" data-mp="ofs6reyjav1n">
                  purchased this digital book
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}